import { c as _c } from "react/compiler-runtime";
const AccordionIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <img src="/static/img/infocar/badge-short.svg" width="37" height="27" alt="Quattroruote Professional" loading="lazy" decoding="async" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export { AccordionIcon };